/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IB2bRequestsTileViewProps } from './b2b-requests-tile';

const B2bRequestsTileView: React.FC<IB2bRequestsTileViewProps> = props => {
    const { b2bRequestsTile, heading, links } = props;

    return (
        <Module {...b2bRequestsTile}>
            {heading}
            {links}
        </Module>
    );
};

export default B2bRequestsTileView;
